import axios from 'axios';
import qryStr from "query-string";
import qs from 'qs'
import router from '../router'

import {Message} from 'element-ui'
axios.defaults.timeout = 50000;
/**
 * 封装get方法
 */

let defaultHeaders = {
    Accept: 'application/json',
    'Access-Control-Allow-Origin': '*',
}
const err = (error) => {
    Message.closeAll();
    if (error.response) {
        const data = error.response.data;
        if (data.code === 401) {
            Message.error(data.message)
        } else if (data.code === 403) {
            Message.error(data.message)
        } else if (data.code === 502) {
            Message.error('连接服务器失败!')
        } else if (data.code === 429) {
            Message.error('访问太过频繁，请稍后再试!')
        }  else if (data.code === 500) {
            Message.error('服务器错误，请联系管理员')
        } else {
            Message.error(data.message)
        }
    } else {
        Message.error({
            content: '连接服务器失败!'
        })
    }
    return Promise.reject(error)
}

const service = axios.create({
    timeout: 30000,
});

service.interceptors.response.use(function (response, error) {
    const status = response.status
    if (status === 200) {
        return Promise.resolve(response)
    }else {
        return Promise.reject(response)
    }
})

export default {
    defaultHeaders: defaultHeaders,
    defaultOptions: {
        credentials: 'same-origin'
    },
    _toQs(body) {
        let qsUrl = {}
        Object.keys(body).forEach((key) => {
            if (body[key] !== undefined) {
                qsUrl[key] = body[key]
            }
        })
        return qryStr.stringify(qsUrl)
    },
    _toForm (body) {
        let form = new FormData()
        Object.keys(body).forEach((key) => {
        if (body[key] !== undefined) {
            form.append(key, body[key])
        }
        })
        return form
    },
    get({url, body = {}, headers = {}, options = {}, reqType = 'json'}) {
        let _this = this;
        if (body && this._toQs(body)) {
            url += `?${this._toQs(body)}`
        }
        options = Object.assign(this.defaultOptions, options)
        let Authorization = sessionStorage.Authorization ? sessionStorage.Authorization : ''
        return new Promise((resolve, reject) => {
            axios.get(url, {
                headers: {
                    ...this.defaultHeaders,
                    Authorization,
                    headers
                },
                ...options
            }).then(response => {
                resolve(response.data);
            }).catch(response => {
                resolve('500')
                // err(response)
                // reject(response.data);
            })
        })
    },
    get_listDetails({url, body = {}, headers = {}, options = {}, reqType = 'json'}) {
        let _this = this;
        url += `/${body}`
        // if (body && this._toQs(body)) {
        //     url += `?${this._toQs(body)}`
        // }
        headers.Authorization = sessionStorage.Authorization ? sessionStorage.Authorization : ''
        options = Object.assign(this.defaultOptions, options)
        return new Promise((resolve, reject) => {
            axios.get(url, {
                headers: {
                    ...this.defaultHeaders,
                    headers
                },
                ...options
            }).then(response => {
                resolve(response.data);
            }).catch(response => {
                err(response)
                reject(response.data);
            })
        })
    },
    /**
     * 封装post请求
     * @param url
     * @param data
     * @returns {Promise}
     */
    postJson({url, body = {}, headers = {}, options = {}, reqType = 'json'}, then) {
        let _this = this;
        options = Object.assign(this.defaultOptions, options)
        let fetchOptions = {
            method: 'POST',
            body: body,
            headers: {
                ...this.defaultHeaders,
                responseType: 'json',
                ...headers
            },
            ...options
        }
        fetchOptions.headers['Content-Type'] = 'application/json;charset=UTF-8'
        fetchOptions.headers['Authorization'] = sessionStorage.Authorization ? sessionStorage.Authorization : ''
        headers = fetchOptions.headers
        return new Promise((resolve, reject) => {
            axios({
                url: url,
                method: 'post',
                data: fetchOptions.body,
                headers: headers
            }).then(response => {
                resolve(response.data);
            }).catch(response => {
                err(response)
                reject(response.data);
            })
        })
    },
    postForm({url, body = {}, headers = {}, options = {}, reqType = 'json'}, then) {
        let _this = this;
        options = Object.assign(this.defaultOptions, options)
        this.defaultHeaders.Authorization = sessionStorage.Authorization
        let fetchOptions = {
        method: 'POST',
        body,
        headers: {
            ...this.defaultHeaders,
            headers,
        },
        ...options
        }
        fetchOptions.body = this._toForm(body)
        fetchOptions.headers['Content-Type'] = 'multipart/form-data'
        fetchOptions.headers['Access-Control-Allow-Origin'] = '*'
        headers = fetchOptions.headers
        return new Promise((resolve, reject) => {
            axios({
                url: url,
                method: 'post',
                data: fetchOptions.body,
                headers: headers
            }).then(response => {
                resolve(response.data);
            }).catch(response => {
                reject(response.data);
            })
        })
    },
    postFile({url, body = {}, headers = {}, options = {}, reqType = 'json'}) {
        options = Object.assign(this.defaultOptions, options)
        this.defaultHeaders.Authorization = sessionStorage.getItem('token')
        let fetchOptions = {
        method: 'POST',
        body,
        headers: {
            ...this.defaultHeaders,
            headers,
        },
        ...options
        }
        fetchOptions.body = this._toForm(body)
        delete fetchOptions.headers['Content-Type']
        return new Promise((resolve, reject) => {
            axios({
                url: url,
                method: 'post',
                data: fetchOptions.body,
                headers: headers
            }).then(response => {
                resolve(response.data);
            }).catch(response => {
                err(response)
                reject(response.data);
            })
        })
    },
}
